var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_621_7119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3333 9.06641H19.6667C21.3333 9.06641 22.6667 10.3997 22.6667 12.0664C22.6667 13.7331 21.3333 15.0664 19.6667 15.0664H12.3333",
    stroke: "#0DCAF0",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3333 15.0664C13.9902 15.0664 15.3333 13.7233 15.3333 12.0664C15.3333 10.4096 13.9902 9.06641 12.3333 9.06641C10.6765 9.06641 9.33333 10.4096 9.33333 12.0664C9.33333 13.7233 10.6765 15.0664 12.3333 15.0664Z",
    stroke: "#0DCAF0",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6667 23.7334H12.3333C10.6667 23.7334 9.33333 22.4001 9.33333 20.7334C9.33333 19.0667 10.6667 17.7334 12.3333 17.7334H19.6667",
    stroke: "#0DCAF0",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6667 23.7334C21.3235 23.7334 22.6667 22.3903 22.6667 20.7334C22.6667 19.0765 21.3235 17.7334 19.6667 17.7334C18.0098 17.7334 16.6667 19.0765 16.6667 20.7334C16.6667 22.3903 18.0098 23.7334 19.6667 23.7334Z",
    stroke: "#0DCAF0",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_621_7119"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8.39941)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryIcon);
export default __webpack_public_path__ + "static/media/category-icon.5b7a063baf46917da815645232705a47.svg";
export { ForwardRef as ReactComponent };